import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'amazonImage', standalone: true })
export class AmazonImagePipe implements PipeTransform {
  transform(imagename: string | undefined | null, size: number): string | null {
    if (!imagename) return null;
    const parts = imagename.split('.');
    parts.splice(1, 0, `_AC_UL${size}_SR${size},${size}_`);
    return `https://images-na.ssl-images-amazon.com/images/I/${parts.join('.')}`;
  }
}
